import { TypographyH2 } from '~/core/ui/Heading'
import LPContainer from './LPContainer'
import { useTranslation } from 'react-i18next'
import { TypographyText } from '~/core/ui/Text'
import Image from 'next/image'

const OurLeadershipSection = () => {
  const { t } = useTranslation()

  const SECTIONS = [
    {
      contentImage: '/img/feature/lp/new/our_leadership_01.png',
      contentTitle: t('aboutUs:our_leadership:section_1_content_title'),
      contentDescription: t(
        'aboutUs:our_leadership:section_1_content_description'
      ),
      contentContent: t('aboutUs:our_leadership:section_1_content_content')
    },
    {
      contentImage: '/img/feature/lp/new/our_leadership_02.png',
      contentTitle: t('aboutUs:our_leadership:section_2_content_title'),
      contentDescription: t(
        'aboutUs:our_leadership:section_2_content_description'
      ),
      contentContent: t('aboutUs:our_leadership:section_2_content_content')
    }
  ]

  return (
    <LPContainer className="desktop:my-[140px] my-[64px]">
      <TypographyH2 className="leading-[52px] font-medium text-gray-900 text-[43px] tablet:text-[61px] tablet:leading-[61px] animate-fadeInUp">
        {t('aboutUs:our_leadership:title')}
      </TypographyH2>
      <div className="mt-10 flex flex-col tablet:flex-row space-y-5 tablet:space-x-5 tablet:space-y-0">
        {SECTIONS.map((item, index) => (
          <div
            key={index}
            className="border border-gray-100 rounded py-6 px-9 flex-1">
            <div className="flex space-x-6 items-center">
              <Image
                src={item.contentImage}
                width={110}
                height={110}
                alt={`${item.contentImage}-image`}
                className="h-auto"
              />
              <div>
                <TypographyText className="text-3xl font-medium text-gray-700">
                  {item.contentTitle}
                </TypographyText>
                <TypographyText className="mt-1 text-lg font-normal text-gray-700">
                  {item.contentDescription}
                </TypographyText>
              </div>
            </div>
            <div className="mt-5">
              <p
                className="text-base text-gray-700"
                dangerouslySetInnerHTML={{ __html: item.contentContent }}
              />
            </div>
          </div>
        ))}
      </div>
    </LPContainer>
  )
}

export default OurLeadershipSection
